<template>
  <div class="nav-bread-kostil">
    <nav-bread :page="{name:'feedSettings', title: $t('breadCrumbs.posts.title'), sub: $t('breadCrumbs.posts.sub')}"/>

    <el-tabs class="full-screen" v-model="activeName" @tab-click="handleClick">
        <el-select class="small-screen" size="small" v-model="activeName" @tab-click="handleClick">
          <el-option
            v-for="item in tabs"
            :value="item.name"
            :label="item.label"
            :key="item.label"
            >
          </el-option>
        </el-select>
      <el-tab-pane
        v-for="item in tabs"
        :label="item.label"
        :name="item.name"
        :key="item.name"
      >
        <component :is="item.component" :active="activeName === item.name"></component>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
/*
  tabs component for analytics wrapper
  use i18n locale
  see http://kazupon.github.io/vue-i18n/started.html for details
*/

// components
import NavBread from '@/components/navBread/NavBread';

export default {
  name: "Tabs",
  data() {
    return {
      activeName: 'publicationsAndComments',
    };
  },
  computed: {
    feed() {
      return this.$store.getters['feed'](this.$route.params.threadId)
        ?
        this.$store.getters['feed'](this.$route.params.threadId)
        :
        [];
    },
    tabs() {
      let tabs;
      if (!this.feed.show_at_map) {
        tabs = this.$t('feedTabs').filter(item => item.name !== 'dynamicBySource');
      } else {
        tabs = this.$t('feedTabs');
      }

      return tabs;
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab);
    }
  },
  components: {
    "Common": () => import("./components/common/Common"),
    "Connections": () => import("./components/connections/Connections"),
    "Source": () => import("./components/source/Source"),
    "ActiveUsers": () => import("./components/activeUsers/ActiveUsers"),
    "PublicationsAndComments": () => import("./components/publicationsAndComments/PublicationsAndComments"),
    "Audit": () => import("./components/audit/Audit"),
    "CommentsList": () => import("./components/commentsList/CommentsList"),
    "TonalMap": () => import("./components/tonalMap/TonalMap"),
    "Thematics": () => import("./components/thematics/Thematics"),
    NavBread,
  }
};
</script>

<style>
  .nav-bread-kostil {
    margin-top: 15px;
  }
  .small-screen{
    display: none;
  }
  @media screen and (max-width: 480px) {
  .full-screen{
    position: absolute;
    left: 0;
    right: 0;
  }
  .el-tabs__nav-wrap{
    display: none;
  }
  .small-screen{
    display: block;
    margin: 5px  25px;
  }
 }
</style>
